import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { VideoPlaySVG } from '../../assets/SVGAssets';
import Button from '../../components/button/Button';
import {
    changeTotalScore,
    setCurrentAnswerStatus,
} from '../../store/sessionStatus';

import './type2_4.css';

export default function Type2_4({ question, answer }) {
    const dispatch = useDispatch();
    const video = useRef();

    const [answers, setAnswers] = useState(question.answers);
    const [disabledButton, setDisabledButton] = useState(false);
    const [playBtn, setPlayBtn] = useState(true);

    const selectAnswer = (i) => {
        setAnswers((prevState) =>
            prevState.map((answer, id) => {
                const newAnswer = i === id ? !answer.answer : answer.answer;
                const newBackground = newAnswer
                    ? 'linear-gradient(315.03deg, #F61FF9 12.51%, #7B61FF 57.57%, #53F2DE 109.73%)'
                    : '';
                return {
                    ...answer,
                    answer: newAnswer,
                    background: newBackground,
                };
            }),
        );
    };

    const checkAnswer = () => {
        setAnswers((prevState) =>
            prevState.map((answer) => {
                const newBackground = answer.isCorrect
                    ? 'linear-gradient(135deg, #48CFAD 0.55%, #19A784 97.3%)'
                    : 'linear-gradient(135deg, #EC87C0 0.55%, #BF4C90 97.3%)';
                return {
                    ...answer,
                    background: newBackground,
                };
            }),
        );

        const status = !answers.some(
            (answer) => answer.isCorrect !== answer.answer,
        );

        dispatch(setCurrentAnswerStatus(status));

        if (status) {
            dispatch(changeTotalScore(question.points));
        }
        setTimeout(answer, 1500);
        setDisabledButton(true);
    };

    const play = () => {
        video.current.requestFullscreen();
        video.current.play();
        setPlayBtn(false);
    };

    return (
        <div className="questionWrapper">
            <div className="type2_4-textArea">{question.text}</div>
            <div className="type2_4-imageArea">
                {question.image ? (
                    <img src={question.image} alt={question.text} />
                ) : (
                    ''
                )}

                {question.video ? (
                    <>
                        <video
                            ref={video}
                            onEnded={(e) => {
                                e.target.webkitExitFullScreen();
                            }}
                            src={question.video}
                            crossOrigin="anonymous"></video>
                        <VideoPlaySVG playBtn={playBtn} playFunction={play} />
                    </>
                ) : (
                    ''
                )}
            </div>

            <div className="type2_4-answerOptions">
                {answers.map((answer, i) => {
                    return (
                        <Button
                            key={i}
                            disabled={disabledButton}
                            type={'squareAnswerButton'}
                            text={answer.text}
                            background={answer.background}
                            action={() => selectAnswer(i)}
                        />
                    );
                })}
            </div>
            <div className="nextQuestionButton">
                <Button
                    disabled={disabledButton}
                    type={'checkButton'}
                    text={'check'}
                    action={checkAnswer}
                />
            </div>
        </div>
    );
}
